import http from '../http/http';
import URL from '../constant/URL';

// 진단학습 최초 예측 조회
export const diagnosisProposalSelAPI = async (learnerId) => {
  let result = null;
  const lrnMbrId = learnerId;
  
  if (!lrnMbrId) {
    throw new Error("undefined lrnMbrId");
  }

  await http.request({
    url: `${URL.API.DIAGNOSIS.INFO}`,
    method: http.METHOD.POST,
    data: { lrnMbrId },
    success: (resp) => {
      localStorage.setItem("ai.diagnosis.check", resp.dgnsYn);
      localStorage.setItem("ai.diagnosis.result.check", resp.dgnsRsltCnfmYn);
      localStorage.setItem("ai.diagnosis.member.check", resp.memberYn);

      result = resp;
    },
    error: (error) => { throw error }
  });

  return result;
}

// 진단테스트 결과
export const diagnosisResultAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${URL.API.DIAGNOSIS.CONFIRM}`,
    method: http.METHOD.PUT,
    data,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      throw error
    }
  })

  return result;
}

// 진단이력 삭제
export const diagnosisResultDelAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${URL.API.LEARNING.HISTORY}`,
    method: http.METHOD.DELETE,
    data,
    success: (resp) => {
      result = true;
    },
    error: (error) => {
      throw error
    }
  });

  return result;
}